import Vue from "vue";
import { ActionTree } from "vuex";
import axios from "@/axios-config/default";
import { IRootState } from "@/store/types";
import { AssetsMutationsNames } from "./enums";
import { IAssetsState } from ".";
import { IUuidsPayload } from "@/store/types";
import { IAsset } from "@/models/asset";

export const actions: ActionTree<IAssetsState, IRootState> = {
    fetchAssetsList({ commit }, ids: IUuidsPayload): void {
        axios
            .get(Vue.prototype.$environmentService.getServicePath("assets"), {
                params: {
                    serviceProviderUuid: ids.uuidSP,
                    contentProviderUuid: ids.uuidCP,
                },
            })
            .then((response) => {
                if (response.status === 200) {
                    // mutation to storage assets list
                    commit(AssetsMutationsNames.SetAssets, response.data);
                }
            })
            .catch((error) => {
                // mutation to storage error
                commit(AssetsMutationsNames.SetError, error);
            });
    },
    setSelectedAsset(this, { commit }, asset: IAsset) {
        commit(AssetsMutationsNames.SetSelected, asset);
    },
    setAssets(this, { commit }, assets: IAsset[]) {
        commit(AssetsMutationsNames.SetAssets, assets);
    },
    resetAssetsState({ commit }): void {
        commit(AssetsMutationsNames.ResetState);
    },
};
